<template>
    <div class="venue__show">
        <div class="venue__show_header">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="venue__show_header_details">
                            <div class="columns">
                                <div class="column">
                                    <view-actions
                                        :cancel-button-active="false"
                                        :notify-title="$t('ebs.venues.show.notifyTitle')"
                                        :size="'small'"
                                        :status-active="true"
                                        :status-name="venueStatus"
                                        :submit-button-text="venueAllowEdit ? this.$t('ebs.venues.show.buttonEdit') : this.$t('ebs.venues.show.buttonView')"
                                        :submit-button-active="user.isInfrastructureManager()"
                                        :title="venueName"
                                        :trash-button-active="user.isInfrastructureManager()"
                                        :breadcrumb-active="true"
                                        :breadcrumb-items="[
                                            {
                                                name: this.$t('ebs.venues.show.nameVenue'),
                                                to: { name: 'ebs-venue-list' }
                                            }
                                        ]"
                                        @emit-notify-remove-submit="venueRemove"
                                        @emit-submit="venueEdit"
                                    />
                                </div>
                            </div>
                            <template v-if="venueDescription">
                                <div class="columns">
                                    <div class="column">
                                        <div class="venue__show_header_details_description">{{venueDescription}}</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <template v-if="venueImages.length">
                        <div class="column is-narrow">
                            <div class="venue__show_header_image">
                                <component-slider
                                    :images="venueImages"
                                    :alt="venueName"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="venue__show_main">
            <div class="container">
                <div class="columns is-block-mobile">
                    <div class="column is-4">
                        <component-location
                            :address="venueAddress"
                        />
                        <template v-if="venueContactPhone || venueContactEmail">
                            <component-contact
                                :title="$t('ebs.venues.show.contact')"
                                :phone="venueContactPhone"
                                :email="venueContactEmail"
                            />
                        </template>
                    </div>
                    <div class="column is-1"></div>
                    <div class="column is-7-tablet is-12-mobile">
                        <room-list
                            :rooms="venueRooms"
                            :venue-id="venueId"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentSlider from '@/components/default/shared/ComponentSlider'
import ComponentLocation from '@/components/default/shared/ComponentLocation'
import ComponentContact from '@/components/default/shared/ComponentContact'
import RoomList from '@/components/ebs/rooms/list/RoomList'
import ViewActions from '@/components/default/shared/ViewActions'
import { User } from '@/User'

export default {
  name: 'venue-show',
  components: {
    ViewActions,
    RoomList,
    ComponentContact,
    ComponentLocation,
    ComponentSlider
  },
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData)
    }
  },
  computed: {
    venueId: function () {
      return this.$store.getters['getVenueId']
    },
    venueName: function () {
      return this.$store.getters['getVenueName']
    },
    venueDescription: function () {
      return this.$store.getters['getVenueDescription']
    },
    venueStatus: function () {
      return this.$store.getters['getVenueStatus']
    },
    venueImages: function () {
      return this.$store.getters.getVenueImages.map(image => {
        return image.fileId
      })
    },
    venueRooms: function () {
      return this.$store.getters['getVenueRooms']
    },
    venueAddress: function () {
      return this.$store.getters['getVenueAddress']
    },
    venueContactEmail: function () {
      return this.$store.getters['getVenueContactEmail']
    },
    venueContactPhone: function () {
      return this.$store.getters['getVenueContactPhone']
    },
    venueAllowEdit () {
      return this.$store.getters.getVenueAllowEdit
    }
  },
  methods: {
    venueEdit: function () {
      this.$router.push({ name: 'ebs-venue-edit', params: { id: this.venueId } })
    },
    venueRemove: function () {
      const venueId = this.$route.params.id
      this.$store.dispatch('removeVenue', venueId)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/venues/venueshow";
</style>
